import React from 'react';
import { connect } from 'react-redux';

import { DatePicker } from 'redpoints-front-components/index';
import { getDefaultDateRanges } from 'redpoints-front-common/helpers';

import { allIncidentsFiltersSetEnforcementDate } from '../../../actions/allIncidentsActions';
import { getAllIncidentsFiltersEnforcementDate } from '../../../reducers/reporting/allIncidents';
import { translate } from '../../../helpers/languageHelper';

const AllIncidentsFiltersEnforcementDate = ({
  allIncidentsFiltersSetEnforcementDate,
  enforcementDate,
}) => {
  const handlerSetEnforcementDate = enforcementDate =>
    allIncidentsFiltersSetEnforcementDate({ enforcementDate });

  return (
    <DatePicker
      label={translate(
        'reporting.allIncidentsInternal.filters.enforcementDate'
      )}
      rangePicker
      ranges={getDefaultDateRanges()}
      onChange={handlerSetEnforcementDate}
      value={enforcementDate || undefined}
    />
  );
};

const mapStateToProps = state => {
  return {
    enforcementDate: getAllIncidentsFiltersEnforcementDate(state),
  };
};

export default connect(mapStateToProps, {
  allIncidentsFiltersSetEnforcementDate,
})(AllIncidentsFiltersEnforcementDate);
